import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {AdminService} from '../admin.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;
  hide = true;
  returnUrl = '/profile';

  constructor(private adminService: AdminService,
              private router: Router,
              private route: ActivatedRoute,
              private snackBar: MatSnackBar
    ) {
    this.email = '';
    this.password = '';
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      params => {
        this.returnUrl = params['return'] || params['url'] || '/profile';
      });
  }

  login() {
    this.adminService.adminLogin(this.email, this.password).subscribe(() => {
      // TODO: After login we need to load the permissions / roles of the logged in user.
      this.adminService.loadProfile().subscribe(() => {
        this.router.navigateByUrl(this.returnUrl).then();
      });
    }, () => {
      this.snackBar.open('Invalid email address or password.', '',
        {
          duration: 2000,
          verticalPosition: 'top',
          panelClass: 'error-snackbar'
        });
    });
  }
}
